import jwt from 'jsonwebtoken';

interface AutoLoginTokenPayload {
  /**
   * The user ID
   */
  userId: string;
  /**
   * The email of the user. Could be an empty string if the user did not provide an email upon registration.
   */
  email: string;
  /**
   * The type of token
   */
  type: 'autoLogin';
}

/**
 * Parses an auto-login JWT token
 * @param {string} token - The JWT auto-login token to parse
 * @returns {{isValid: boolean, payload: AutoLoginTokenPayload|null}} The parsed token data
 */
export function parseAutoLoginToken(token: string) {
  try {
    const decoded = jwt.decode(token) as AutoLoginTokenPayload;

    if (!decoded || !decoded.userId || !decoded.type || decoded.type !== 'autoLogin') {
      return { isValid: false, payload: null };
    }

    return {
      isValid: true,
      payload: decoded,
    };
  } catch (error) {
    console.error('Error parsing auto-login token:', error);
    return { isValid: false, payload: null };
  }
}
